import React, { useEffect, useState, useMemo, memo } from "react"
import { useParams } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"
import ErrorAccess from "@/components/common/ErrorAccess"
import Box from "@material-ui/core/Box"
import Loading from "@/components/common/Loading"
import { getParticipantByParticipantUUID, resendInvitationLink } from "@/apisParticipantPublic"
import clsx from "clsx"
import InvitationMain from "@/components/invitation"
import InvitationContext from "@/components/invitation/InvitationContext"
import { errorApiMessage, errorMessageClient, errorCode } from "@/constants"

const useStyles = makeStyles(() => ({}))

const Invitation = memo((props) => {
    const { participantCheckLoading, participantDetail, updateParticipant } = props
    const { participantUUID } = useParams()
    const classes = useStyles()
    const [participant, setParticipant] = useState({
        active: null,
        firstName: "",
        lastName: "",
        projectManager: null,
        roleId: null,
        departmentId: null,
        designationId: null,
        projectProductId: null,
        projectIndustryId: null,
        init: true,
    })
    const [participantLoading, setParticipantLoading] = useState({
        loading: true,
        error: false,
        message: "",
    })
    const [participantDetailError, setParticipantDetailError] = useState({
        status: false,
        message: "",
        update: false,
    })
    const requestSnackbarValue = useHandleRequestSnackbar(true)

    const handleUpdateParticipant = (key, value) => {
        setParticipant((prev) => ({ ...prev, [key]: value }))
        updateParticipant(null, key, value)
    }
    // retrieved participant detail
    useEffect(() => {
        const retrieveParticipant = async (uuid) => {
            try {
                const participantDetailData = await getParticipantByParticipantUUID(uuid)
                const participantDetailRespondedResult = participantDetailData.data.participant
                setParticipantLoading({ loading: false, error: false })
                setParticipant((prev) => ({
                    ...prev,
                    active: participantDetailRespondedResult.active,
                    firstName: participantDetailRespondedResult.firstName,
                    lastName: participantDetailRespondedResult.lastName,
                    projectManager: participantDetailRespondedResult.projectManager,
                    projectProductId: participantDetailRespondedResult.projects.productId,
                    projectIndustryId: participantDetailRespondedResult.projects.industryId,
                    roleId: participantDetailRespondedResult.roleId,
                    departmentId: participantDetailRespondedResult.departmentId,
                    designationId: participantDetailRespondedResult.designationId,
                    init: false,
                }))
            } catch (error) {
                setParticipantLoading({ loading: false, error: true, message: error.data.message || "error" })
            }
        }
        if (!participantCheckLoading.error) retrieveParticipant(participantUUID)
    }, [])

    const participantError = useMemo(() => {
        if (participantCheckLoading.message === errorApiMessage.participantNotFound) {
            return <ErrorAccess message={errorMessageClient.participantNotFound} />
        }
        if (participantCheckLoading.errorCode === errorCode.participantPublicAccessTokenInvalid) {
            return (
                <ErrorAccess
                    message="send new invitation link"
                    buttonText="send"
                    buttonCallback={() => resendInvitationLink(participantUUID)}
                />
            )
        }
        return <ErrorAccess />
    }, [participantCheckLoading, participantUUID])

    return (
        <>
            {participantCheckLoading.error ? (
                <>{participantError}</>
            ) : (
                <Box className="invitation-wrapper">
                    {participantLoading.loading ? (
                        <Box className={clsx(classes.contentWrapper, classes.loading)}>
                            <Loading content="Loading Participants Detail ..." transformX={90} />
                        </Box>
                    ) : (
                        <>
                            {participantLoading.error || (participantDetailError.status && !participantDetailError.update) ? (
                                <ErrorAccess />
                            ) : (
                                !participant.init && (
                                    <InvitationContext.Provider
                                        value={{
                                            participantDetail,
                                        }}
                                    >
                                        <InvitationMain
                                            participantLoading={participantLoading}
                                            participant={participant}
                                            participantUUID={participantUUID}
                                            handleUpdateParticipant={handleUpdateParticipant}
                                            setParticipantDetailError={setParticipantDetailError}
                                        />
                                    </InvitationContext.Provider>
                                )
                            )}
                        </>
                    )}
                    {participantLoading.error ||
                        (participantDetailError.status && (
                            <RequestSnackbar
                                status={false}
                                message={participantLoading.message || participantDetailError.message}
                                snackbarOpen={requestSnackbarValue.snackbarOpen}
                                handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
                            />
                        ))}
                </Box>
            )}
        </>
    )
})

export default Invitation
